import type { TabItem } from './TabbedContent';

export enum FeatureDetailsTab {
  About = 'about',
  Configuration = 'configuration',
}

export const UNDERWRITER_PRODUCT_TEST_IDS = {
  enableButton: 'other-underwriters-button-enable',
  disableButton: 'other-underwriters-button-disable',
  enableDialog: {
    accept: 'other-underwriters-enable-button-accept',
    close: 'other-underwriters-enable-button-close',
    cancel: 'other-underwriters-enable-button-cancel',
  },
  disableDialog: {
    disableAddOn: 'other-underwriters-disable-button-disable-add-on',
    close: 'other-underwriters-disable-button-close',
    cancel: 'other-underwriters-disable-button-cancel',
  },
  aboutTab: 'product-tab-about',
  configurationTab: 'product-tab-configuration',
  manageUnderwriterLink: 'product-configuration-link-manage-underwriter',
  manageUnderwritersDrawer: {
    search: 'manage-underwriters-input-search',
    selectAll: 'manage-underwriters-checkbox-select-all',
    save: 'manage-underwriters-button-save-changes',
    cancel: 'manage-underwriters-button-cancel',
    close: 'manage-underwriters-button-close',
    // FormHeader appends 'close' to build the cross icon test id.
    crossQAPrefix: 'manage-underwriters-button-',
    warning: 'manage-underwriters-drawer-warning',
    noResults: 'manage-underwriters-drawer-no-results',
    underwriterCard: 'manage-underwriters-drawer-card',
    underwriterCheckbox: 'manage-underwriters-checkbox',
  },
} as const;

export interface FeatureDetailsTabItemsOptions {
  testIdPrefix: string;
  disableConfiguration?: boolean;
  useUnderwriterProductTestIds?: boolean;
}

export const getFeatureDetailsTabItems = ({
  testIdPrefix,
  disableConfiguration = false,
  useUnderwriterProductTestIds = false,
}: FeatureDetailsTabItemsOptions): TabItem[] => [
  {
    label: 'About',
    id: FeatureDetailsTab.About,
    testId: useUnderwriterProductTestIds ? UNDERWRITER_PRODUCT_TEST_IDS.aboutTab : `${testIdPrefix}-tab-about`,
  },
  {
    label: 'Configuration',
    id: FeatureDetailsTab.Configuration,
    testId: useUnderwriterProductTestIds
      ? UNDERWRITER_PRODUCT_TEST_IDS.configurationTab
      : `${testIdPrefix}-tab-configuration`,
    disabled: disableConfiguration,
  },
];
